export default function unmount(){
  window.removeEventListener('pushstate', this.urlListener);
}
